import Theme from '@ucheba/utils/helpers/styles/variables'

const themeProject = new Theme()

export default themeProject
